export default "PRIVACY POLICY TBA\n"